import { StoreModelMap } from 'client/util/Constants';
import { extend } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: {
    /**
     * Mixin getters and actions to child component so it has access to the
     * item being created or edited in an Aside Panel.
     * @param options The instantiation options used for the current Vue instance.
     * @param mapToParent Set to true when a BodyComponent needs access to the
     * parent object in an Aside Panel. BodyComponents are passed an item, which
     * is the item in the Item Table row they're rendered in. So when a Body
     * Component also needs access to the parent item being created or updated
     * in an aside panel, the getters and setters need to be mapped to different
     * names to avoid conflicts with existing props, and to clearly differentiate
     * between the parent item modeled by the Aside Panel and the Item rendered
     * in an Item Table row.
     * @todo This method can be moved out of the methods property and into
     * its own top level beforeCreate() hook assuming the mapToParent parameter
     * can be exposed as data on the component. Hook functions can be mixed in
     * and they will be executed in the order of the mixins in the component's
     * mixins array before the component's own hook functions.
     * @see https://vuejs.org/v2/guide/mixins.html#Option-Merging
     */
    asidePanelChildComponentHandleBeforeCreate(options, mapToParent = false) {
      const storeModel = StoreModelMap[options.propsData.parentType];

      let gettersMap;
      let actionsMap;

      if (mapToParent) {
        gettersMap = {
          isParentBeingCreated: 'isItemBeingCreated',
          isParentBeingUpdated: 'isItemBeingUpdated',
          parent: 'item',
        };
        actionsMap = {
          setParentField: 'setItemField',
          unset: 'unset',
        };
      } else {
        gettersMap = [
          'isItemBeingCreated',
          'isItemBeingUpdated',
          'item',
          'previousItem',
        ];
        actionsMap = [
          'setItemField',
          'setPreviousItemField',
          'unset',
        ];
      }

      extend(options.computed, mapGetters(storeModel, gettersMap));
      extend(options.methods, mapActions(storeModel, actionsMap));
    },
  },
};
